import React, { FC, PropsWithChildren, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useQuery } from '@apollo/client';
import { Outlet, useParams } from 'react-router-dom';

import Container from 'components/common/Container';
import TemplatePageHeader from 'components/headers/TemplatePageHeader';
import { EventContextProvider } from 'components/context/EventContext';

import { GET_TEMPLATE } from 'graphql/queries/template';

import useStyles from 'pages/events/EventLayout/style';

const TemplateLayout: FC<PropsWithChildren> = () => {
  const classes = useStyles();

  const { id: templateId } = useParams<keyof EventPageRouteParams>();

  const { data, error, loading } = useQuery<GetTemplateResponse>(GET_TEMPLATE, {
    variables: { templateId },
    fetchPolicy: 'cache-and-network',
    skip: !templateId,
  });

  const ref = useRef<Nullable<HTMLDivElement>>(null);

  const template = data?.getTemplate;

  useEffect(() => {
    const container = ref.current?.querySelector('.eventLayoutContainer') as Maybe<HTMLDivElement>;

    !loading && container?.focus();
  }, [loading]);

  if (error || (loading && !template)) {
    return null;
  }

  return (
    <div ref={ref} className={classNames(classes.eventLayout, 'isTimeline')} id="eventLayout">
      <EventContextProvider
        value={{
          isLoading: loading,
          event: (template as unknown) as EventItem,
        }}
      >
        <TemplatePageHeader />
        <Container
          className={classNames('eventLayoutContainer content-fade-in', {
            ready: !!template && !loading,
          })}
        >
          {!!template && !loading ? <Outlet /> : null}
        </Container>
      </EventContextProvider>
    </div>
  );
};

export default TemplateLayout;
